import { SubTableColumn } from 'src/components/commons/subTable/types';

const COLUMNS: SubTableColumn[] = [
  {
    key: 'name',
    title: 'NAME',
    dataIndex: 'name',
    editable: true,
    minWidth: 580,
    dataType: 'string',
    unique: true,
    required: true,
    hidden: false,
    dataStructure: 'string',
    headerName: 'name',
    options: [],
    orderField: 'name',
    searchField: 'name',
  },
];

export default COLUMNS;
